/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import Text from 'src/components/ts-components/Text'
import { StatusIndicatorProps } from './types'
import { getStatusInfo } from './utils'

/**
 * Status indicator with colored dot and label
 * Matches Figma design: green dot for "Approved", etc.
 */
const StatusIndicator = ({ statusId, statusLabel }: StatusIndicatorProps) => {
  const statusInfo = getStatusInfo(statusId)

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        gap: 6px;
      `}
    >
      {/* Status Dot */}
      <div
        css={css`
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: ${statusInfo.color};
          flex-shrink: 0;
        `}
      />
      {/* Status Label */}
      <Text variant='paragraphSmall' weight='regular' color={colors.WHITE}>
        {statusLabel}
      </Text>
    </div>
  )
}

export default StatusIndicator
